import { ThunkAction } from "redux-thunk";
import { IExtra, RootAction, RootState } from "../types";

import {
  updateLineProgress,
  fetchLinesProgress,
  createLineProgress,
  deleteLineProgress,
} from "../actions";

import { ILineUpdate, ILine, LineID } from "../api/APIClient";

export function updateLine(
  update: ILineUpdate
): ThunkAction<void, RootState, IExtra, RootAction> {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(updateLineProgress.request(update));

      const line = await api.updateLine(update);

      dispatch(updateLineProgress.success(line));
    } catch (err) {
      dispatch(updateLineProgress.failure(err));
    }
  };
}

export function createLine(
  line: ILine
): ThunkAction<void, RootState, IExtra, RootAction> {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(createLineProgress.request(line));

      line = await api.createLine(line);

      dispatch(createLineProgress.success(line));
    } catch (err) {
      dispatch(createLineProgress.failure(err));
    }
  };
}

export function deleteLine(
  id: LineID
): ThunkAction<void, RootState, IExtra, RootAction> {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(deleteLineProgress.request(id));

      const line = await api.deleteLine(id);

      dispatch(deleteLineProgress.success(line));
    } catch (err) {
      dispatch(deleteLineProgress.failure(err));
    }
  };
}

export function fetchLines(): ThunkAction<void, RootState, IExtra, RootAction> {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(fetchLinesProgress.request());

      const lines = await api.listLines();

      dispatch(fetchLinesProgress.success(lines));
    } catch (err) {
      dispatch(fetchLinesProgress.failure(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/thunks/lineThunks.ts